import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, ApiError } from '../../lib/api';
import { useAuth } from '../../lib/auth';
import { can } from '../../lib/permissions';

type Result = { total: number; rows: { id: string; serial_no: string; item_code?: string; review_label?: string }[] };
export function RelatedLegacySerials({ kind, id }: { kind: 'contract_id' | 'delivery_id'; id: string }) {
  const { user } = useAuth();
  const [page, setPage] = useState(0);
  const [data, setData] = useState<Result | null>(null);
  const [error, setError] = useState('');
  const allowed = can(user, 'physical-assets', 'view');
  useEffect(() => { setPage(0); }, [id]);
  useEffect(() => {
    if (!allowed) return;
    let active = true;
    setData(null); setError('');
    api.get<{ data: Result }>(`/api/migration/legacy-serials?${kind}=${encodeURIComponent(id)}&limit=20&offset=${page * 20}`)
      .then((r) => { if (active) setData(r.data); })
      .catch((e) => { if (active) setError(e instanceof ApiError ? e.message : '历史序列号加载失败'); });
    return () => { active = false; };
  }, [kind, id, page, allowed]);
  if (!allowed) return null;
  return <section style={{ marginTop: 16 }}>
    <h4>关联历史序列号{data ? `（${data.total}）` : ''}</h4>
    {error ? <div className="notice bad">{error}</div> : !data ? <div className="muted">加载中…</div> : <>
      {data.rows.length ? <table className="lines"><thead><tr><th>序列号</th><th>源物料</th><th>核查状态</th></tr></thead><tbody>
        {data.rows.map((r) => <tr key={r.id}><td><Link to={`/legacy-serials?serial_id=${encodeURIComponent(r.id)}`}>{r.serial_no}</Link></td><td>{r.item_code || '—'}</td><td>{r.review_label || '—'}</td></tr>)}
      </tbody></table> : <div className="muted">暂无关联历史序列号</div>}
      {data.total > 20 ? <div className="detail-actions"><button className="btn" disabled={!page} onClick={() => setPage(page - 1)}>上一页</button><span>{page + 1} / {Math.ceil(data.total / 20)}</span><button className="btn" disabled={(page + 1) * 20 >= data.total} onClick={() => setPage(page + 1)}>下一页</button></div> : null}
    </>}
  </section>;
}
